import API, { API_URL } from "api/API";
import { ApiResult, ForecastObsInfo } from "libs/types";

interface GetForecastInfoApiResult extends ApiResult {
  data: ForecastObsInfo[];
}

async function getForecastInfoApi():Promise<GetForecastInfoApiResult> {
  const {data} = await API.get(`${API_URL.FORECAST.GET_OBS_INFO}`);

  return data;
}

export default getForecastInfoApi;